<template>
  <section class="fields">
    <dropdown-select
      class="six wide inputSelect"
      :required="required"
      :items="formattedKeys"
      :placeholder-text="$tc('TYPE', 1)"
      :select-handler="keySelected"
      :disabled="isDisabled"
    ></dropdown-select>

    <div class="field">
      <input
        id="inputName"
        type="text"
        :required="required"
        autocomplete="off"
        :placeholder="$t('NAME')"
        v-model="value"
        :disabled="isDisabled"
      />
    </div>

    <footer>
      <button
        type="button"
        class="circular ui icon button"
        @click.prevent="addKeyValuePair"
        :disabled="isDisabled"
      >
        <i class="icon checkmark"></i>
      </button>
    </footer>
  </section>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../../scss/variables';

.ui.label {
  margin: 3px;
}

.inputSelect {
  position: relative;
  z-index: 10;
}
</style>

<script>
// @flow
import Vue from 'vue'
import { DropdownSelect } from 'ui'

export default {
  name: 'key-value-input',
  components: { DropdownSelect },

  props: {
    keys: {
      type: Array,
      default: () => []
    },
    addHandler: {
      type: Function,
      default: () => ''
    },
    isDisabled: {
      type: Boolean,
      default: () => false
    },
    required: {
      type: Boolean,
      default: () => false
    }
  },

  computed: {
    formattedKeys() {
      return (
        this.keys.map(k => {
          return { name: k, id: k }
        }) || []
      )
    }
  },

  data() {
    return {
      key: '',
      value: ''
    }
  },

  methods: {
    addKeyValuePair() {
      if (this.value && this.key) {
        this.addHandler({ key: this.key, value: this.value })
        this.value = ''
        this.key = this.keys ? this.keys[0] : ''
      }
    },
    keySelected(key) {
      this.key = key.id
    }
  },
  watch: {
    keys: function() {
      if (this.keys && this.keys.length > 0) {
        this.key = this.keys[0]
      } else {
        this.key = ''
      }
    }
  }
}
//
</script>
